module.exports = __webpack_public_path__ + "img/video.b2425e37.svg";